import moment from "moment";
import { INotification, NOTIFICATIONS_BY_ENV } from "../constants/NOTIFICATION";
import { today } from "./dateTimeUtils";
import configuration from "./configuration";


export const getNotification = (): INotification | null => {
    const env = configuration.envName;
    const notificationByEnv = NOTIFICATIONS_BY_ENV[env];
    
    if (!notificationByEnv) return null;

    const now = today();
    const from = moment(notificationByEnv.from, "YYYY-MM-DDTHH:mm");
    const to = moment(notificationByEnv.to, "YYYY-MM-DDTHH:mm");

    return now.isBetween(from, to, "minute", "[]") ? notificationByEnv : null;
};